import store from "@/store"

class Api {
  async _init() {
    window.playmore = { media: window._media, device: window._device, platform: window._platform }
    await this.loadResources()
    await _$.sleep(2000)
    await this.makeConfigurations()

    this.addListeners()

    if (playmore.device.run) {
      playmore.device.run("rm -rf /data/data/com.android.providers.downloads/cache/*", false)

      if (playmore.device.run("cat /vendor/build.prop | grep -i 'fingerprint=Playmore'", true))
        playmore.device.run(
          "mount -o rw,remount / && mount -o rw,remount /vendor && sed -i 's/fingerprint=Playmore/fingerprint=Amlogic/g' /vendor/build.prop && sed -i 's/fingerprint=Playmore/fingerprint=Amlogic/g' /system/build.prop && mount -o ro,remount / && mount -o ro,remount /vendor && reboot",
          false
        )
      this.manifestChecker()
    }

    // Do anything when the worker is ready
    //_$.vue.$once("worker.init", () => {})
    // Do anything when the config is init // updated
    _$.vue.$once("config.init", () => {
      if (
        (__.device.get("type") === "jedi" && __.device.config("jedi.videojs")) ||
        (__.device.get("type") === "playmore" && __.device.config("playmore.videojs"))
      ) {
        __._hls = __._hlsVideoJS
        __._vod = __._hlsVideoJS
      }
    })

    return true
  }

  addListeners() {
    document.onkeydown = e => _$.nav.onKeyDown({ keyCode: e.detail }, ![3].includes(e.detail))
    document.onkeyup = e => ([209, 64].includes(e.detail) ? _$.nav.onKeyDown({ keyCode: e.detail }, false) : _$.nav.onKeyUp())

    document.addEventListener(
      "stbEvent",
      event => {
        const events = Object.keys(event.detail)
        events.forEach(key => _$.handler.emit(key, event.detail[key]))
      },
      false
    )

    _$.vue.$on(["applicationFocused"], async () => {
      if (!store.state.router || __.device.get("type") === "jedi") return
      if (playmore.device.isMouseOpen()) {
        const container = document.getElementById("staticPopup")
        const res = await _$.loadImage("/assets/images/airmouse_deactivate.jpg", false, true)
        if (res) {
          _$.nav.disable()
          let promiseMouse = await _$.progress.create()
          container.appendChild(res)
          _$.vue.$emit("toplevel", true)
          container.style.display = "inherit"
          container.style.zIndex = "99"
          _$.vue.$once("airMouseDeactive", () => {
            _$.nav.enable()
            container.innerHTML = ""
            container.style.display = "none"
            container.style.zIndex = "-1"
            promiseMouse.resolve()
            _$.sleep(1000).then(() => _$.vue.$emit("toplevel", false))
          })
          await promiseMouse.done
        }
      }
    })

    _$.vue.$once("ready", () => this.hdmiSyncChecker())

    _$.vue.$on("hdmiSinkDevice", res => {
      if (res === "turnedOn") return
      switch (__.device.config("hdmi.cec")) {
        case "reboot":
          __.device.reboot()
          break
        case "soft":
          __.platform.toPlatform()
          break
        case "hard":
          __.platform.go()
          break
      }
    })
  }
  async makeConfigurations() {
    window._media.stop()
    window._media.setDisplayMetrics(1920, 1080, 0, 0, "BEHIND")
    return true
  }
  async loadResources() {
    _$.loader.createObject("div", {
      style: "display:none; top:0; left:0; right:0; bottom:0; position:fixed; z-index:-1;",
      id: "staticPopup"
    })
    return true
  }
  async getProperties() {
    try {
      return JSON.parse(playmore.device.getProperties())
    } catch (err) {
      return _$.error(err)
    }
  }
  async manifestChecker() {
    const { applications } = await fetch("/PMB/manifest.json").then(res => res.json())

    for (const application of applications) {
      if (application.packageName.startsWith("com.playroomtv")) continue

      const version_ = playmore.device.run(`dumpsys package ${application.packageName} | grep versionName | awk 'NR==1'`, true)

      const installedVersion = version_?.replace(/versionName=/, "").trim()

      if (application.version !== installedVersion) {
        console.log(`Uninstalling ${application.packageName}: manifest=${application.version}, installed=${installedVersion}`)
        playmore.device.run(`pm uninstall ${application.packageName}`, false)
      }
    }
  }
  async hdmiSyncChecker() {
    return true
    /*
    if (playmore.platform.getConfig("displayMode")) {
      const configs = JSON.parse(playmore.platform.getConfig())
      delete configs.displayMode
      playmore.platform.syncConfig(JSON.stringify(configs))
    }
    if (!playmore.device.displayMode) return
    return __._api.hdmiSync().finally(() => setInterval(() => __._api.hdmiSync(), 180000))
    */
  }
  async hdmiSync() {
    return true
    /*
    let currentDisplayMode = playmore.device.displayMode(),
      savedDisplayMode = playmore.platform.getConfig("_displayMode")

    if (savedDisplayMode === "null" || savedDisplayMode == "576" || savedDisplayMode === "off") {
      playmore.platform.syncConfig("{}")
      return _$.sleep(1000).then(() => playmore.device.reboot())
    }

    if (this.dmState(currentDisplayMode) === "off") return //576cvbs
    if (!this.dmState(savedDisplayMode) && this.dmState(currentDisplayMode)) playmore.platform.setConfig("_displayMode", currentDisplayMode)

    if (!this.dmState(currentDisplayMode) && this.dmState(savedDisplayMode)) return playmore.device.displayMode(savedDisplayMode)
    else if (!this.dmState(currentDisplayMode) && !this.dmState(savedDisplayMode)) return playmore.device.reboot()

    if (this.dmState(savedDisplayMode) > 1080) return

    const targetDisplayMode = __.device.config("hdmi.sync")
    if (targetDisplayMode && targetDisplayMode !== currentDisplayMode) return playmore.device.displayMode(targetDisplayMode)

    return true*/
  }
  dmState(val) {
    let regexp = /(\d)+/g,
      res = val?.match(regexp)?.shift()

    if (res) res = parseInt(res)
    if (res === 576) return "off"
    return res || 0
  }
}

export default Api
